// @flow
import type { Person, PersonPayload } from '@person/type';

import { formatAddressFromPayload } from '@shared/Locations/services/AddressUtils';

export const hydratePersonFromPayload = (person: PersonPayload): Person => ({
  id: person.id,
  address: person.address ? formatAddressFromPayload(person.address) : null,
  birthDate: new Date(person.birthDate),
  email: person?.email ?? '',
  emergencyContact: {
    firstName: person?.emergencyContact?.firstName ?? '',
    lastName: person?.emergencyContact?.lastName ?? '',
    mobilePhone: person?.emergencyContact?.mobilePhone ?? '',
    landlinePhone: person?.emergencyContact?.landlinePhone ?? '',
    relationship: person?.emergencyContact?.relationship ?? '',
  },
  firstName: person.firstName,
  landlinePhone: person?.landlinePhone ?? '',
  lastName: person.lastName,
  mobilePhone: person?.mobilePhone ?? '',
  sexe: person.sexe,
  type: person.type,
  shapeUser: person?.shapeUser,
  prescriber: person?.prescriber ?? null,
  groupClassTermsAcceptedAt: person?.groupClassTermsAcceptedAt ? new Date(person.groupClassTermsAcceptedAt) : null,
});
